import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, of, tap, catchError } from 'rxjs';
import { environment } from 'environments/environment';

export interface MaintenanceInfo {
  isMaintenanceScheduled: boolean;
  maintenanceStartDate?: string;
  maintenanceEndDate?: string;
  maintenanceStartTime?: string;
  maintenanceEndTime?: string;
  maintenanceMessage?: string;
  maintenanceDuration?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  private baseUrl = environment.apiUrlV1;
  private maintenanceInfo$ = new BehaviorSubject<MaintenanceInfo | null>(null);
  private hasChecked = false;

  constructor(private http: HttpClient) {}

  /**
   * Get maintenance information
   * This method ensures the API is only called once and caches the result
   */
  getMaintenanceInfo(): Observable<MaintenanceInfo> {
    // If we've already checked, return the cached result
    if (this.hasChecked && this.maintenanceInfo$.value) {
      return of(this.maintenanceInfo$.value);
    }

    // If we haven't checked yet, make the API call
    if (!this.hasChecked) {
      this.hasChecked = true;
      this.fetchMaintenanceInfo().subscribe();
    }

    return this.maintenanceInfo$.asObservable();
  }

  /**
   * Fetch maintenance information from API
   */
  private fetchMaintenanceInfo(): Observable<MaintenanceInfo> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    });
    console.warn('Maintenance API not available, using mock data for testing');
    const mockInfo: MaintenanceInfo = {
      isMaintenanceScheduled: false,
      maintenanceStartDate: '2025-07-29',
      maintenanceEndDate: '2025-07-30',
      maintenanceStartTime: '21:00',
      maintenanceEndTime: '01:00',
      maintenanceMessage: 'Scheduled maintenance for system updates and improvements.',
      maintenanceDuration: '4 hours'
    };
    this.maintenanceInfo$.next(mockInfo);
    return of(mockInfo);
    // return this.http.get<MaintenanceInfo>(`${this.baseUrl}maintenance/status`, { headers })
    //   .pipe(
    //     tap((info: MaintenanceInfo) => {
    //       this.maintenanceInfo$.next(info);
    //     }),
    //     catchError((error) => {
    //       // For testing purposes, return a mock response if API is not available
    //       console.warn('Maintenance API not available, using mock data for testing');
    //       const mockInfo: MaintenanceInfo = {
    //         isMaintenanceScheduled: true,
    //         maintenanceStartDate: '2025-07-29',
    //         maintenanceEndDate: '2025-07-30',
    //         maintenanceStartTime: '21:00',
    //         maintenanceEndTime: '01:00',
    //         maintenanceMessage: 'Scheduled maintenance for system updates and improvements.',
    //         maintenanceDuration: '4 hours'
    //       };
    //       this.maintenanceInfo$.next(mockInfo);
    //       return of(mockInfo);
    //     })
    //   );
  }

  /**
   * Clear cached maintenance info (useful for testing or force refresh)
   */
  clearCache(): void {
    this.hasChecked = false;
    this.maintenanceInfo$.next(null);
  }
} 